export const translate = {
  internationalize: (country, message) =>
    country === 'Argentina' || country === 'Uruguay'
      ? translate.ARG_UY[message]
      : translate.LATAM[message],
  ARG_UY: {
    title: '¡Hay muchas formas de ahorrar!',
    subtitle: 'Mirá todas las opciones debajo y cuidá tu bolsillo',
    tyc: 'Consultá los ',
    tooltip:
      'Podés agregar nuevos medios de pago cuando elijas como pagar tu pedido.',
    offer: 'Aprovechá',
    save: '¡Ahorrá',
    qcSubtitle: '¡Aprovechá hoy estos descuentos!',
    qcBannersTitle: '¡Disfrutá ofertas y novedades!',
    vendorItem: {
      ETA: {
        default: 'Envío con normalidad',
        quick: 'Envío rápido',
        delay: 'Envío con demora',
      },
      shipping: {
        plusFree: 'Envío gratis con PedidosYa Plus',
        plusDiscount: 'Envío con descuento de PedidosYa Plus',
      },
      images: {
        header: 'Imagen de portada del local',
        logo: 'Logo del local',
      },
    },
    errorMessage404: {
      id: 'app.components.ErrorVendorList.404',
      defaultTitle: 'No hay locales disponibles',
      defaultDescription: 'Podés probar más tarde.',
      landingItem: {
        defaultTitle: 'No hay productos disponibles',
        defaultDescription: 'Podés probar más tarde.',
      },
    },
    errorMessage500: {
      id: 'app.components.ErrorVendorList.500',
      defaultTitle: 'Hubo un error en la carga',
      defaultDescription: 'Intentá nuevamente para cargar locales disponibles.',
    },
    errorMessage500Items: {
      id: 'app.components.ErrorVendorList.500',
      defaultTitle: 'Hubo un error en la carga',
      defaultDescription:
        'Intentá nuevamente para cargar productos disponibles.',
    },
    errorMessageBadConnection: {
      id: 'app.components.ErrorLanding.500',
      defaultTitle: 'Algo no funciona',
      defaultDescription:
        'Hubo un problema al cargar la página. Inténtalo de vuelta.',
      defaultMessageButton: 'VOLVER A CARGAR',
    },
    errorMessageReload: {
      id: 'app.components.ErrorVendorList.reload',
      defaultMessage: 'Volver al inicio',
    },
    errorMessageReloadItems: {
      id: 'app.components.ErrorVendorList.reload',
      defaultMessage: 'Volver a intentar',
    },
    emptyStateFiltersItems: {
      id: 'app.components.EmptyStateFilters.clean',
      defaultTitle: 'No encontramos resultados para estos filtros',
      defaultDescription: 'Por favor, limpialos y probá con otros.',
      defaultMessage: 'Limpiar filtros',
    },
  },
  LATAM: {
    title: '¡Hay muchas formas de ahorrar!',
    subtitle: 'Mira todas las opciones debajo y cuida tu bolsillo',
    tyc: 'Consulta los ',
    tooltip:
      'Puedes agregar nuevos medios de pago cuando elijas como pagar tu pedido.',
    offer: 'Aprovecha',
    save: '¡Ahorra',
    qcSubtitle: '¡Aprovecha hoy estos descuentos!',
    qcBannersTitle: '¡Disfruta ofertas y novedades!',
    vendorItem: {
      ETA: {
        default: 'Envío con normalidad',
        quick: 'Envío rápido',
        delay: 'Envío con demora',
      },
      shipping: {
        plusFree: 'Envío gratis con PedidosYa Plus',
        plusDiscount: 'Envío con descuento de PedidosYa Plus',
      },
      images: {
        header: 'Imagen de portada del local',
        logo: 'Logo del local',
      },
    },
    errorMessage404: {
      id: 'app.components.ErrorVendorList.404',
      defaultTitle: 'No hay locales disponibles',
      defaultDescription: 'Puedes probar más tarde.',
      landingItem: {
        defaultTitle: 'No hay productos disponibles',
        defaultDescription: 'Puedes probar más tarde.',
      },
    },
    errorMessage500: {
      id: 'app.components.ErrorVendorList.500',
      defaultTitle: 'Hubo un error en la carga',
      defaultDescription: 'Intenta nuevamente para cargar locales disponibles.',
    },
    errorMessage500Items: {
      id: 'app.components.ErrorVendorList.500',
      defaultTitle: 'Hubo un error en la carga',
      defaultDescription:
        'Intenta nuevamente para cargar productos disponibles.',
    },
    errorMessageBadConnection: {
      id: 'app.components.ErrorLanding.500',
      defaultTitle: 'Algo no funciona',
      defaultDescription:
        'Hubo un problema al cargar la página. Intente nuevamente.',
      defaultMessageButton: 'VOLVER A CARGAR',
    },
    errorMessageReload: {
      id: 'app.components.ErrorVendorList.reload',
      defaultMessage: 'Volver al inicio',
    },
    errorMessageReloadItems: {
      id: 'app.components.ErrorVendorList.reload',
      defaultMessage: 'Volver a intentar',
    },
    emptyStateFiltersItems: {
      id: 'app.components.EmptyStateFilters.clean',
      defaultTitle: 'No encontramos resultados para estos filtros',
      defaultDescription: 'Por favor, limpialos y prueba con otros.',
      defaultMessage: 'Limpiar filtros',
    },
  },
};
